import React from 'react';
import Button from '@/components/Button';
import ExternalLink from '@/components/ExternalLink';
import Icon from '@/components/Icon';
import { settingsManageCurrentPlanPath } from '@/routes';

const CHAT_WHATSAPP_URL = 'https://wa.me/5511953287748?text=Quero%20adquirir%20o%20Agendor%20Chat';

function AgendorChatAddonsCard({ isPaid }) {
  return (
    <div className='d-flex justify-content-between align-items-center py-5'>
      <div className='d-flex'>
        <div className='d-inline-block p-1 me-2'>
          <div
            className='p-1 rounded bg-primary bg-opacity-10 text-dark-gray lh-0 position-relative'
          >
            <Icon name='whatsapp' />
          </div>
        </div>
        <div>
          <h5>Agendor Chat</h5>
          <span className='text-small text-medium-gray'>
            Conecte seus vendedores, transfira conversas, crie anotações
            <br />privadas, use automações e veja relatórios em tempo real!
          </span>
        </div>
      </div>
      <div className='d-flex flex-column align-items-end'>
        {isPaid && (
          <Button
            variant='light-primary'
            size='sm'
            className='mb-1 width-4 text-primary'
            href={settingsManageCurrentPlanPath()}
            state={{ target: { type: 'chat' } }}
          >
            Gerenciar
          </Button>
        )}
        {!isPaid && (
          <Button
            as={ExternalLink}
            variant='light-primary'
            size='sm'
            className='mb-1 width-4 text-primary'
            target={'_blank'}
            href={CHAT_WHATSAPP_URL}
          >
            Adquirir Chat
          </Button>
        )}
        <Button
          variant='outline-primary'
          size='sm'
          className='width-4'
          as={ExternalLink}
          target={'_blank'}
          href='https://www.agendor.com.br/lps/agendor-chat'
        >
          <Icon name='external-link' size='sm' className='me-1' />
          Saiba mais
        </Button>
      </div>
    </div>
  );
}

export default AgendorChatAddonsCard;
